/**
 * Labelled <select> with inline error display.
 * Accepts the same options array format as categories.js.
 */
export default function SelectField({
  label,
  id,
  options = [],
  error,
  className = '',
  required = false,
  ...props
}) {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {label && (
        <label htmlFor={id} className="text-sm font-semibold text-brand-dark">
          {label}
          {required && <span className="text-red-500 ml-0.5">*</span>}
        </label>
      )}
      <select
        id={id}
        className={`form-field appearance-none bg-white ${error ? 'form-field-error' : ''}`}
        {...props}
      >
        {options.map(({ value, label: optLabel, disabled }) => (
          <option key={value} value={value} disabled={disabled}>
            {optLabel}
          </option>
        ))}
      </select>
      {error && (
        <p className="text-xs text-red-500 font-medium mt-0.5">{error}</p>
      )}
    </div>
  )
}
